import {Map} from '@gongxigames/framework/core/types';
import {consoleLogger} from '@gongxigames/framework/core/fragments/ConsoleLogger';

export type CreateFunction<T> = () => T;

/**
 * @deprecated
 */
export class DisplayObjectsPool<T> {

    // object that are in use (renderer, updater, etc.)
    protected _inUseObjects: Map<T[]> = {};

    // free pool of objects
    protected _freeObjects: Map<T[]> = {};

    // factory functions that create objects by name
    protected _factoryFunctions: Map<CreateFunction<T>> = {};

    public addFactoryFunction(name: string, func: CreateFunction<T>): this {
        if (this._factoryFunctions[name]) {
            consoleLogger.warn(`factory function ${name} already exist`);

            return this;
        }

        this._factoryFunctions[name] = func;

        return this;
    }

    public get(name: string): T {
        if (this.isFreeObjectExist(name)) {
            if (this._factoryFunctions[name]) {
                const obj = this._factoryFunctions[name]();

                this.use(name, obj);

                return obj;
            }

            // TODO: need refactor;
            throw new Error('not implemented');
        }

        const displayObject = this._freeObjects[name].pop()!;

        this.use(name, displayObject);

        return displayObject;
    }

    public add(name: string, displayObject: T): void {
        if (!this._freeObjects[name]) {
            this._freeObjects[name] = [];
        }

        this._freeObjects[name].push(displayObject);
    }

    public use(name: string, displayObject: T): void {
        if (!this._freeObjects[name]) {
            this._freeObjects[name] = [];
        }

        if (!this._inUseObjects[name]) {
            this._inUseObjects[name] = [];
        }

        this._inUseObjects[name].push(displayObject);
    }

    public free(name: string, displayObject: T): void {
        if (this._inUseObjects[name]) {
            const index = this._inUseObjects[name].indexOf(displayObject);

            if (index !== -1) {
                this._inUseObjects[name].splice(index, 1);
                this.add(name, displayObject);

                return;
            }
        }

        consoleLogger.warn(`object ${name} wasn't used`);
    }

    public freeAll(): void {
        for (const name in this._inUseObjects) {
            if (this._inUseObjects.hasOwnProperty(name)) {
                for (const obj of this._inUseObjects[name]) {
                    this.free(name, obj);
                }
            }
        }
    }

    protected isFreeObjectExist(name: string): boolean {
        return !this._freeObjects[name] || !this._freeObjects[name].length;
    }
}
